<template>
  <div class="page">
    <navigation
      type="second-level"
      :sticky="true"
      @click="detention"
      :customClickEvent="true"
      v-if="!showPayLoading"
    >
      我要提现
    </navigation>

    <!-- 顶部金额信息 -->
    <div class="amount-info">
      <div class="title">
        <span>提现金额 (元)</span>
        <img src="./image/img_withdraw_passcard_reviewFree.png"/>
      </div>
      <div class="amount">{{ form.applyAmt | amount}}</div>
      <div class="split" />
      <img class="bottom-banner" src="./image/img_withdraw_passcard_banner.png" />
    </div>
    <!-- 表单 -->
    <form class="form card-panel">
      <div class="form-item underline-un-focus">
        <nd-choose
          label="怎么花"
          :valueKey="['key', 'description']"
          :data="dictionary.loanPurpose"
          v-model="form.purpose"
          @change="purposeChange"
        >
        </nd-choose>
      </div>

      <div class="form-item underline-un-focus">
        <nd-choose
          label="分几期"
          :data="termList"
          :placeholder="placeholder"
          v-model="form.applyTerm"
          :beforeClick="beforeSelectTerm"
          @change="termChange"
        >
        </nd-choose>
      </div>
    </form>
    <div class="tips" v-if="!canLoanApply">
      {{ canotLoanReason }}
    </div>
    <section class="bottom">
      <nd-button class="confirm" @click="next" :disabled="isDisabled">{{ canLoanApply ? '下一步：预览提现详情' : '暂不可提现'}}</nd-button>
      <section class="read-protocol">
        <span>综合年化利率以实际每笔订单放款审核为准</span>
      </section>
    </section>

    <nd-dialog v-model="detentionVisible" :footer="false" class="detention-dialog">
      <div class="detention-dialog-content">
        <div class="detention-title">
          <span>立即</span>提现，<span>秒速</span>审批，<span>即刻</span>到账
        </div>
        <ul class="giveup">
          <li  @click="dismissAndPop(1)">
            无法修改提现金额
          </li>
          <li  @click="dismissAndPop(2)">
            我不想拿钱了
          </li>
        </ul>

        <button class="continue" @click="continueApply">继续提现</button>
      </div>
    </nd-dialog>

    <div class="pay-loading" v-if="showPayLoading">
      <span class="back" @click="backHome">返回首页</span>
      <div class="lottie-contaienr">
        <lottie
          ref="animataion"
          :options="showGif"
        />
        <p>订单支付中</p>
      </div>
    </div>

    <service-pass v-model="isBigPrivilegeRefund" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ServicePass from './components/service-pass.vue'
import { getKey, judgeClientSystem } from '@/assets/utils'
import { hasNativeMethod, jsBridge } from '@/assets/jsBridge'
import Lottie from 'vue-lottie'
import { wait } from '@/assets/json/index'
import { removeKey } from '../../assets/utils'
const WITHDRAW_PASSCARD_FORM_KEY = 'withdrawForm'
export default {
  name: 'passCard',
  components: {
    ServicePass,
    Lottie
  },
  data () {
    return {
      detentionVisible: false,
      productSubList: [],
      amtProductList: [],
      fundCode: '',
      canLoanCode: '',
      canLoanApply: true,
      canotLoanReason: '',
      showPayLoading: false,
      showGif: { animationData: wait },
      orderNo: this.$route.query.partnerOrderNumber,
      form: {
        applyAmt: '',
        applyTerm: '',
        purpose: '',
        bankCardNo: ''
      },
      isBigPrivilegeRefund: false
    }
  },
  computed: {
    ...mapState({
      dictionary: state => state.dictionary
    }),
    termList () {
      if (!this.productSubList || this.productSubList.length === 0) {
        return []
      }
      var cycles = this.amtProductList.map((item) => {
        return {
          name: item + '个月',
          value: item
        }
      })
      return cycles
    },
    placeholder () {
      return this.termList.length > 0 ? '请选择' : '暂无支持分期'
    },
    isDisabled () {
      return !(
        this.form.applyAmt &&
        this.form.applyTerm &&
        this.form.purpose &&
        this.canLoanApply
      )
    }
  },
  async created () {
    // partnerOrderNumber
    if (this.orderNo) {
      await this.pollBuyVipResult()
    } else {
      this.init()
    }
    this.$bus.$emit('ready')
  },
  beforeDestroy () {
    clearTimeout(window.timmer)
  },
  methods: {
    ...mapActions('withdraw', [
      'getLoanParameterX',
      'amtProductX',
      'getFundRouteX',
      'canLoanX',
      'judgeMissingX',
      'getLoanTrialX'
    ]),
    ...mapActions('vip', ['buyVipResult']),
    ...mapActions(['fetchDictionaryX']),
    async init () {
      await this.fetchDictionary()
      await this.getLoanParameter()
      await this.getAmountProduct(this.form.applyAmt)
      await this.canLoan()
    },
    // 轮询通过buyVipResult查询是否购买成功
    async pollBuyVipResult () {
      this.showPayLoading = true
      const { success, data } = await this.buyVipResult({
        orderNo: this.orderNo
      })
      if (success) {
        const { memberOpenStatus } = data
        // INIT :初始化 WAIT :准备开通 CANCEL :取消 SUC :成功 FAIL :失败
        if (['INIT', 'WAIT'].includes(memberOpenStatus)) {
          window.timmer = setTimeout(() => {
            this.pollBuyVipResult()
          }, 3000)
        } else if (memberOpenStatus === 'SUC') {
          this.showPayLoading = false
          this.init()
        } else {
          this.$router.push('/middle/limit')
        }
      }
    },
    async fetchDictionary () {
      await this.fetchDictionaryX()
    },
    // 查询借款参数
    async getLoanParameter () {
      const response = await this.getLoanParameterX({
        loanPlatform: 'TMD',
        passCardProcess: 'Y'
      })
      if (response.success && response.data) {
        this.form.applyAmt = response.data.productDefaultAmt
        this.productSubList = response.data.productSubList
      }
      // 默认借款用途
      const allLoanPurposeKeys = this.dictionary.loanPurpose.map(item => item.key)
      if (this.dictionary.defaultLoanPurpose && allLoanPurposeKeys.includes(this.dictionary.defaultLoanPurpose)) {
        this.form.purpose = this.dictionary.defaultLoanPurpose
      }
    },
    // 通过金额查询子产品 - 分期数据来源
    async getAmountProduct (applyAmount) {
      const response = await this.amtProductX({
        loanPlatform: 'TMD',
        applyAmount: applyAmount,
        passCardProcess: 'Y'
      })
      if (response.success) {
        let terms = response.data
        this.amtProductList = terms
        if (terms && terms.length > 0) {
          this.form.applyTerm = terms[terms.length - 1]
        }
      } else {
        this.amtProductList = []
      }
    },
    // 当前是否可借款
    async canLoan () {
      const response = await this.canLoanX({
        loanPlatform: 'TMD',
        applyAmount: this.form.applyAmt || '',
        totalTermNo: this.form.applyTerm || '',
        passCardProcess: 'Y'
      })
      if (response.success) {
        const { code, canLoanApply, message } = response.data
        this.canLoanCode = code
        this.canLoanApply = canLoanApply
        this.canotLoanReason = message
        if (code === 'F_000051') {
          // 未做OCR
          this.judge({ h5: '/authentication/id', native: 'ocr' })
        } else if (code === 'F_000023') {
          // OCR过期
          this.$router.replace('/authentication/supplementaryOCR?status=expired')
        } else if (code === 'F_000054') {
          this.$router.replace({
            path: '/withdraw/poor-credit',
            query: {
              status: 'time',
              count: message
            }
          })
        }
      }
    },
    async getFundRoute () {
      const params = {
        routeType: 'LOAN',
        loanPlatform: 'TMD',
        applyAmount: this.form.applyAmt,
        totatlTermNo: this.form.applyTerm,
        productCode: 'TMDP',
        passCardProcess: 'Y'
      }
      const response = await this.getFundRouteX(params)
      if (response.code === '100002') {
        this.$router.push({ path: '/withdraw/svip/middle', query: { svipSource: 1, purchaseSVIP: 'middle' } })
        return
      }

      if (response.code === '100006') {
        this.isBigPrivilegeRefund = true
        return
      }
      if (response.success) {
        if (response.data.length === 0) {
          this.$message('今日额度已抢完，明天再来吧')
        } else {
          this.$storage.set('fundRoute', response.data[0])
          this.fundCode = response.data[0].fundCode
        }
      } else {
        this.$storage.remove('fundRoute')
        this.$message(response.msg)
      }
    },
    async next () {
      // 不能借款时，拦截
      const canLoanRes = await this.canLoanX({
        loanPlatform: 'TMD',
        applyAmount: this.form.applyAmt || '',
        totalTermNo: this.form.applyTerm || '',
        passCardProcess: 'Y'
      })
      if (!canLoanRes.success || !canLoanRes.data.canLoanApply) {
        return
      }
      this.$indicator()
      await this.getFundRoute()
      if (!this.fundCode) {
        this.$indicator.close()
        return
      }
      const response = await this.getLoanTrialX({
        loanTerm: this.form.applyTerm,
        withdrawAmt: this.form.applyAmt,
        loanPlatform: 'TMD',
        fundCode: this.fundCode,
        repayMethod: 'AI',
        productCd: 'TMDP'
      })
      this.$indicator.close()
      if (response.success) {
        this.$storage.set('repayTrail', response.data)
        const res = await this.judgeMissingX()
        this.$storage.set(WITHDRAW_PASSCARD_FORM_KEY, this.form)
        if (res.success && res.data.missing) {
          let value = getKey('channel') !== 'API-XHQB' ? 'F' : 'T'
          this.$router.push({
            path: '/authentication/smallFlowerBase',
            query: { notify: value, fundCode: this.fundCode, passCardProcess: 'Y' }
          })
        } else {
          removeKey('withdrawButtonHasBeenClicked')
          this.$router.push({
            path: '/withdraw/preview',
            query: { fundCode: this.fundCode, passCardProcess: 'Y', couponSerialNos: this.$route.query.couponSerialNos }
          })
        }
      }
    },
    checkAndroid () {
      if (hasNativeMethod('navigateTo') && judgeClientSystem() !== 'IOS') {
        jsBridge('navigateTo', { path: 'withdraw', exitCurrent: true })
      }
    },
    detention () {
      if (this.canLoanApply) {
        this.detentionVisible = true
      } else {
        this.backHome()
      }
    },
    // 无法修改金额或我不想拿钱了，点击后触发，返回
    dismissAndPop (index) {
      this.$report({
        id: 10120,
        args: {
          target: index
        }
      })
      this.detentionVisible = false
      this.$nextTick(() => {
        this.backHome()
      })
    },
    continueApply () {
      this.$report({
        id: 10120,
        args: {
          target: 0
        }
      })
      this.detentionVisible = false
    },
    beforeSelectTerm () {
      if (this.termList.length === 0) {
        // this.$message('当前没有可匹配的期数')
        return Promise.resolve(false)
      }
      return Promise.resolve(true)
    },
    // 怎么花
    purposeChange (item) {
      this.$report({
        id: 10088,
        args: {
          target: item.value
        }
      })
      console.log(this.form)
    },
    // 期数选择
    termChange (item) {
      this.$report({
        id: 10089,
        args: {
          target: item.value
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.page {
  background: #FAFAFA;
  .pay-loading {
    position: absolute;
    width: 100vw;
    height: 100vh;
    top: 0;
    display: flex;
    background: #fff;
    justify-content: center;
    .back {
      float: right;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      text-decoration: underline;
      text-align: right;
      padding:30px;
      z-index: 9;
      position: absolute;
      right: 0;
    }
    .lottie-contaienr {
      margin-top: 300px;
      width: 210px;
      height: 210px;
    }
    p {
      font-size: 34px;
      text-align: center;
      margin-top: 30px;
      font-weight: bold;
    }
  }
  .amount-info {
    margin-top: 20px;
    background: #FFFFFF;
    padding: 60px 0 0;
    .title {
      font-size: 30px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      display: flex;
      align-items: center;
      padding: 0 40px;
      span {
        margin-right: 19px;
      }
      img {
        width: 80px;
        height: 46px;
      }
    }
    .amount {
      font-size: 72px;
      font-family: DIN-Medium, DIN;
      font-weight: 500;
      color: #333333;
      line-height: 87px;
      padding: 0 40px;
    }
    .split {
      height: 1px;
      background: #EEEEEE;
      margin: 16px 40px 0;
    }
    .bottom-banner {
      width: 100%;
      padding: 0;
    }
  }
  .card-panel {
    background-color: #fff;
    margin-top: 20px;
  }
  .form {
    padding: 0 30px;
    .form-item {
      height: 110px;
      line-height: 110px;
      margin-top: 0;

      .nd-choose {
        label {
          font-size: 30px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
        }

        input {
          font-size: 30px;
        }

        textarea {
          font-size: 30px;
        }
      }
    }
  }
  .tips {
    padding: 11px 40px;
    background: #FFF9F1;
    font-size: 24px;
    color: #FF8864;
    line-height: 33px;
  }
  .bottom {
    width: 750px;
    height: 230px;
    background: #fff;
    box-shadow: 0 0 8px 0 #000 4%;
    position: fixed;
    bottom: 0;
    .read-protocol {
      width: 100%;
      text-align: center;
      margin-top: 25px;
      span {
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 33px;
      }
    }
    .confirm {
      margin: 30px auto 0;
      width: 650px;
      height: 94px;
      background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
      border-radius: 47px;
    }
  }
  .detention-dialog {
    .detention-title {
      margin: 0 20px;
      text-align: center;
      font-size: 36px;
      line-height: 50px;
      font-family: PingFangSC-Medium,PingFang SC;
      font-weight: 500;
      padding-bottom: 34px;
      border-bottom: 1px solid #EEEEEE;
      span {
        font-size:36px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(255,70,51,1);
        line-height:50px;
      }
    }

    .giveup {
      li {
        height: 110px;
        line-height: 110px;
        text-align: center;
        font-size: 30px;
        font-family: PingFangSC-Regular,PingFang SC;
        font-weight: 400;
        color: @fc3;
        border-bottom: 1px solid #EEEEEE;
      }
    }

    .continue {
      border: 0px solid transparent;
      height: 160px;
      line-height: 160px;
      text-align: center;
      font-size: 36px;
      font-family: PingFangSC-Medium,PingFang SC;
      font-weight: 500;
      color: @theme;
      width: 100%;
      -webkit-appearance: none;
      outline: none;
      background-color: #FFFFFF;
    }
  }
}</style>
